export interface Stage {
  name: StageName;
  displayName: string;
  authApiUrl: string;
  cantamusUrl: string;
  chargebeeSite: string;
  graphqlHttpUrl: string;
  vocloudUrl: string;
}

export const production: Stage = {
  name: "production",
  displayName: "Production",
  authApiUrl: "https://backend.cantamus.app",
  cantamusUrl: "https://cantamus.app",
  chargebeeSite: "voctrolabs",
  graphqlHttpUrl: "https://backend.cantamus.app/hasura/v1/graphql",
  vocloudUrl: "https://cloud.voctrolabs.com/api",
};

export const staging: Stage = {
  name: "staging",
  displayName: "Staging",
  authApiUrl: "https://backend-staging.cantamus.app",
  cantamusUrl: "https://staging.cantamus.app",
  chargebeeSite: "voctrolabs-test",
  graphqlHttpUrl: "https://backend-staging.cantamus.app/hasura/v1/graphql",
  vocloudUrl: "https://cloud-staging.voctrolabs.com/api",
};

export const development: Stage = {
  name: "development",
  displayName: "Development",
  authApiUrl: "http://localhost:3000/auth",
  cantamusUrl: "http://localhost:3000",
  chargebeeSite: "voctrolabs-test",
  graphqlHttpUrl: "http://localhost:3000/hasura/v1/graphql",
  vocloudUrl: "http://localhost:3001/api",
};

const stages = {
  development,
  production,
  staging,
};
export default stages;

export type StageName = keyof typeof stages;

// Check if a string is a stage name (and return the correct StageName type)
export function isStageName(stageName: string): stageName is StageName {
  return Object.keys(stages).find((name) => name === stageName) !== undefined;
}
